<template>
  <Loading v-if="loading" />
  <Modal v-if="showModalQuickReservation" @close="closeModal">
    11111
    <div class="quickReservation">
      <div class="quickReservation__header">
        <span class="title">{{ $t('quickReservationLockers') }}</span>
        <img
          src="@/assets/icons/CloseModal.svg"
          alt="CloseModal"
          @click="closeModal"
        />
      </div>
      <div class="quickReservation__body">
        <FormKit
          type="form"
          id="quickReservation-form"
          v-model="formData"
          :actions="false"
          @submit="submitHandler"
        >
          <div
            class="quickReservation__body-lockers"
            v-for="(locker, index) in lockers"
            :key="index"
            :data-testid="'quickReservationLockers' + index"
          >
            <div class="lockers-info">
              <div class="size-locker">
                <p>{{ $t(locker.label) }}</p>
              </div>
              <div class="quantity-lockers">
                <p>{{ quantityLockers[locker.code] }}</p>
              </div>
            </div>
            <Input
              type="number"
              :name="locker.label"
              :max="defaultQuantityLockers[locker.code]"
              :min="0"
              :onkeydown="'return false'"
              @click="handleChange"
            />
          </div>
          <div class="quickReservation__body-deliveryInfo">
            <div class="deliveryInfo-kolliID">
              <Input
                v-for="el in kolliID"
                :key="el.id"
                :type="el.type"
                :name="el.name"
                :label="$t(el.label)"
                :data-testid="el.id"
              />
            </div>
            <Input
              type="tel"
              name="phoneNumber"
              :label="$t('phoneNumber')"
              :validation="[['required'], ['matches', /^\+[0-9]{10,14}$/]]"
              validation-visibility="dirty"
              :validationMessages="{
                matches: $t('validation.phoneNumber'),
                required: $t('validation.required')
              }"
            />
          </div>
          <Checkbox
            name="is_drug"
            :value="formData.is_drug"
            :title="$t('isDrug')"
            @change="formData.is_drug = !formData.is_drug"
          />
          <div class="quickReservation__body-ssn" v-if="formData.is_drug">
            <label class="label-ssn" for="ssn">
              {{ $t('ssn') }}
            </label>
            <Input v-model="formData.ssn" type="text" name="ssn" />
          </div>
        </FormKit>
      </div>
      <div class="quickReservation__buttons">
        <Button
          class="quickReservation__buttons-button"
          :variant="
            this.defaultQuantityLockers !== this.quantityLockers
              ? 'filled'
              : 'disabled'
          "
          :title="$t('reserve')"
          :disabled="
            this.defaultQuantityLockers !== this.quantityLockers ? false : true
          "
          @click="submitForm"
        />
        <Button
          variant="redBordered"
          :title="$t('cancel')"
          @click="closeModal"
        />
      </div>
    </div>
  </Modal>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapActions, mapState } from 'vuex';

import Loading from '@/views/Loading.vue';

import {
  DataQuickReservation,
  DataSortLocker,
  Locker,
  Module
} from '@/store/modules/pharmacy/types';

import { lockers, kolliID } from './configs';
import { InputFileEvent } from '@/types';

@Options({
  name: 'QuickReservation',
  props: ['showModalQuickReservation', 'activePickupBox', 'lockersActiveBox'],
  emits: ['closeModal'],
  components: {
    Loading
  },
  data() {
    return {
      formData: {
        lockerId: [],
        deliveryId: '',
        additionalDeliveryId1: '',
        additionalDeliveryId2: '',
        phoneNumber: '',
        is_drug: false,
        ssn: ''
      },
      loading: false,
      validationRules: {},
      pickupBoxOptions: [],
      lockers,
      selectedLockers: 0,
      lockerId: [],
      quantityLockers: { 0: 0, 1: 0, 2: 0, fridge: 0 },
      defaultQuantityLockers: { 0: 0, 1: 0, 2: 0, fridge: 0 },
      numberSelectedLockers: {},
      kolliID
    };
  },
  computed: {
    ...mapState('account', ['user']),
    ...mapState('pharmacy', ['pickupBoxes'])
  },
  created() {
    this.loadPickupBoxes();
  },
  methods: {
    ...mapActions('pharmacy', [
      'createReservation',
      'getPharmacy',
      'getPickupBoxesByPharmacy'
    ]),
    async loadPickupBoxes() {
      this.loading = true;

      this.defaultQuantityLockers = this.lockersActiveBox;
      this.quantityLockers = this.defaultQuantityLockers;

      this.loading = false;
    },
    handleChange(e: InputFileEvent) {
      const { name, value } = e.target;

      if (name) {
        if (+value < 0) {
          value;
        }

        if (name === 'small' && this.defaultQuantityLockers[0] !== 0) {
          this.quantityLockers = {
            ...this.quantityLockers,
            0: this.defaultQuantityLockers[0] - +value
          };
        } else if (name === 'medium' && this.defaultQuantityLockers[1] !== 0) {
          this.quantityLockers = {
            ...this.quantityLockers,
            1: this.defaultQuantityLockers[1] - +value
          };
        } else if (name === 'large' && this.defaultQuantityLockers[2] !== 0) {
          this.quantityLockers = {
            ...this.quantityLockers,
            2: this.defaultQuantityLockers[2] - +value
          };
        } else if (
          name === 'fridge' &&
          this.defaultQuantityLockers['fridge'] !== 0
        ) {
          this.quantityLockers = {
            ...this.quantityLockers,
            fridge: this.defaultQuantityLockers['fridge'] - +value
          };
        }
      }
    },
    getNumberSelectedLockers() {
      if (this.defaultQuantityLockers !== this.quantityLockers) {
        this.numberSelectedLockers = {
          0: this.defaultQuantityLockers[0] - this.quantityLockers[0],
          1: this.defaultQuantityLockers[1] - this.quantityLockers[1],
          2: this.defaultQuantityLockers[2] - this.quantityLockers[2],
          fridge:
            this.defaultQuantityLockers['fridge'] -
            this.quantityLockers['fridge']
        };
      }
    },
    getLockersId() {
      this.lockersId = [];
      this.modules = this.activePickupBox?.info.modules;

      const allModulesLockers = this.modules
        .map((module: Module, idx: number) =>
          module.lockers.map((locker: Locker) => ({
            ...locker,
            moduleId: module.id ?? idx
          }))
        )
        .flat();

      const selectedLockersNumber = Object.entries(
        this.numberSelectedLockers
      ).filter(
        (lockerTypeAmount: [string, unknown]) => lockerTypeAmount[1] !== 0
      );

      selectedLockersNumber.forEach((selectedLocker: [string, unknown]) => {
        const lockersOfOneType = allModulesLockers
          .filter(
            (locker: Locker) =>
              ((locker.type === +selectedLocker[0] && !locker.fridge) ||
                (locker.fridge && selectedLocker[0] === 'fridge')) &&
              !locker.order &&
              !locker.inactive &&
              locker.state !== 'disabled'
          )
          .sort(
            (a: DataSortLocker, b: DataSortLocker) => a.openCount - b.openCount
          );

        if (lockersOfOneType.length) {
          const lockerData = selectedLocker[1] as number;

          for (let i = 0; i < lockerData; i++) {
            if (lockersOfOneType[i]) {
              this.lockersId.push(
                `${lockersOfOneType[i].moduleId}-${lockersOfOneType[i].position}`
              );
            }
          }
        }
      });

      return this.lockersId;
    },
    async submitHandler(data: DataQuickReservation) {
      this.getNumberSelectedLockers();
      this.getLockersId();

      this.dataAdditionalDeliveryIds = [
        this.formData.additionalDeliveryId1,
        this.formData.additionalDeliveryId2
      ];

      const payload = {
        ...data,
        userId: this.user.id,
        lockerId: this.lockersId,
        additionalDeliveryIds: [...this.dataAdditionalDeliveryIds]
      };

      delete payload.small;
      delete payload.medium;
      delete payload.large;
      delete payload.fridge;
      delete payload.additionalDeliveryId1;
      delete payload.additionalDeliveryId2;

      this.loading = true;
      await this.createReservation({
        data: payload,
        boxId: this.activePickupBox.id
      });

      const { id } = this.$route.params;
      await this.getPharmacy(id);
      await this.getPickupBoxesByPharmacy(id);

      this.$formkit.reset('quickReservation-form');
      this.$emit('closeModal');
      this.loading = false;
    },
    submitForm() {
      this.$formkit.submit('quickReservation-form');
    },
    closeModal() {
      this.$emit('closeModal');
      this.$formkit.reset('quickReservation-form');
    }
  }
})
export default class QuickReservation extends Vue {}
</script>

<style lang="scss" scoped>
.quickReservation {
  width: 460px;
  height: 100%;
  .quickReservation__header {
    display: flex;
    justify-content: space-between;
    padding: 24px 24px 0 24px;
    .title {
      font-family: 'Ubuntu-Medium';
      font-size: $eighteenSize;
      line-height: 14px;
    }
    img {
      cursor: pointer;
    }
  }
  .quickReservation__body {
    margin: 24px;
    .quickReservation__body-dropdown {
      height: 40px;
      width: 411px;
    }
    .formkit-form {
      margin-top: 24px;
      .quickReservation__body-lockers {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 11px;
        &:last-child {
          margin-bottom: 0;
        }
        .lockers-info {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 150px;
          .quantity-lockers {
            width: 40px;
            height: 20px;
            text-align: center;
            border: 1px solid $main-green;
            border-radius: 8px;
            p {
              border-radius: 8px;
              margin: 2px 0;
            }
          }
        }
        .input {
          width: 70px;
          height: 40px;
          margin-bottom: 0;
          .formkit-outer {
            height: 40px;
            .formkit-wrapper {
              height: 40px;
              .formkit-inner {
                .formkit-input {
                  height: 40px;
                }
              }
            }
          }
        }
      }
      .quickReservation__body-ssn {
        position: relative;
        width: 412px;
        height: 48px;
        margin-top: 24px;
        label {
          position: absolute;
          font-family: 'Ubuntu-Regular';
          top: -6px;
          left: 15px;
          padding: 0 5px;
          background: $white;
          color: $label;
          font-weight: 400;
          font-size: $twelveSize;
          line-height: $fourteenSize;
          z-index: 1;
        }
      }
    }
  }
  .quickReservation__buttons {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 412px;
    padding: 24px;
    padding-top: 0;
    .button {
      width: 200px;
    }
    .quickReservation__buttons-button {
      margin-right: 12px;
    }
  }
}
</style>

<style lang="scss">
.quickReservation__body-deliveryInfo {
  .deliveryInfo-kolliID {
    display: flex;
    justify-content: space-between;
    height: 78px;
    margin-top: 24px;
    .formkit-outer {
      margin-bottom: 38px;
      .formkit-wrapper {
        .formkit-inner {
          width: 130px;
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }
}
</style>
